import React from "react";

interface LayoutFullBleedProps {
    children?: React.ReactNode;
    className?: string;
}

export const LayoutFullBleed: React.FC<LayoutFullBleedProps> = ({
                                    children,
                                    className = "",
                                }: LayoutFullBleedProps) => {

    return <>
        <div className={`l-fullbleed l-fullbleed--white ${className}`}>
            {children}
        </div>
    </>;
};
